import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ErrorBanner/>\n<div id=\"mainContainer\">\n	{{outlet}}\n</div>\n",{ moduleName: "bullitt-time-results/templates/application.hbs" })